<template>
  <!-- Desktop Dialog -->
  <global-dialog-card
    v-if="!device.isMobile"
    v-model="model"
    :title="$t('order_details')"
    max-width="700px"
    hide-actions
  >
    <company-menu-food-order-card
      class="mt-3"
      :meal="meal"
      :daily-menu="dailyMenu"
      :shift="shift"
    ></company-menu-food-order-card>
  </global-dialog-card>

  <!-- Mobile Bottom Sheet -->
  <v-bottom-sheet v-else v-model="model" max-width="500">
    <v-card>
      <v-card-title
        class="primary white--text d-flex flex-row align-center justify-space-between"
      >
        <span>{{ $t("order_details") }}</span>
        <v-btn icon dark @click="model = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0 black--text">
        <!-- Large image -->
        <v-img :src="mealImage" height="250" cover />

        <!-- Content -->
        <div class="pa-4">
          <p class="text-center subtitle-1 font-weight-bold">
            {{
              localeDate(currentMenuDate, {
                weekday: "long",
              })
            }},
            {{ localeDate(currentMenuDate) }}
          </p>

          <!-- Shift name with lines -->
          <div class="d-flex align-center mb-4">
            <v-divider class="flex-grow-1"></v-divider>
            <span class="mx-3 text-body-2 font-weight-medium">{{ shiftName }}</span>
            <v-divider class="flex-grow-1"></v-divider>
          </div>

          <!-- Meal name -->
          <h2 class="text-h6 font-weight-bold mb-2 text-center">
            {{ toLatin(meal.name) }}
          </h2>

          <p class="text-body-2 text-center mb-7 mt-4" v-if="meal.description">
            {{ translate(meal.description) }}
          </p>
          <!-- Tag (if applicable) -->
          <v-chip v-if="meal.type" class="mb-4" small color="grey lighten-3">
            {{ meal.type }}
          </v-chip>

          <div
            v-if="showPrice && meal.price"
            class="text-body-2 text-center font-weight-medium mb-4"
          >
            <span class="primary--text">{{ meal.price }}</span> {{ restaurantCurrency }}
          </div>

          <!-- Quantity controls -->
          <div class="d-flex align-center justify-center mb-4">
            <circle-button
              icon="mdi-minus"
              color="primary"
              :disabled="isDisabledCard || quantity <= 0"
              @click="updateQuantity(-1)"
            />
            <span class="mx-4 headline font-weight-bold">{{ quantity }}</span>
            <circle-button
              icon="mdi-plus"
              color="primary"
              :disabled="isDisabledCard"
              @click="updateQuantity(1)"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasMenuOrdering from "@/mixins/hasMenuOrdering";
import CompanyMenuFoodOrderCard from "@/components/companyMenu/cards/CompanyMenuFoodOrderCard.vue";

export default {
  name: "CompanyMenuFoodOrderDialog",
  props: {
    meal: {
      type: Object,
      required: true,
    },
    dailyMenu: {
      type: Object,
      required: true,
    },
    shift: {
      type: String,
      required: true,
    },
  },
  mixins: [hasModel, hasMenuOrdering],
  components: {
    CompanyMenuFoodOrderCard,
  },
  computed: {
    showPrice() {
      const company = this.$store.state.company;
      if (!company.settings) return false;
      const settings = JSON.parse(company.settings);
      return !!settings?.show_price;
    },
    shiftName() {
      const shifts = this.shift.split("-");
      let code = null;
      if (shifts) {
        code = "shift_" + shifts[0];
      }
      const translation = (this.$store.state.company?.shift_translations || []).find(
        (st) => {
          return st.shift_code === code && st.language_code === this.$i18n.locale;
        }
      );
      return translation?.label || this.$t(code) || code || this.shift;
    },
    currentMenuDate() {
      return this.$store.state.companyMenu.currentMenuDate;
    },
    isDisabledCard() {
      return (
        this.dailyMenu.disabled ||
        (this.dayTo > this.dailyMenu.date && !this.params.checkTime)
      );
    },
  },
};
</script>
